import React, { FC, useEffect, useState } from "react";
import { QuestionProps } from "../../../pages/form";
import { Col, InputNumber, Row, Slider } from "antd";
import { SurveyUnitOptionSelect } from "./components/unit-select";
import { useDebouncedCallback } from "use-debounce";

interface IntQuestionProps extends QuestionProps {
  clinicId: string;
}

export const IntQuestion: FC<IntQuestionProps> = ({
  question,
  answer,
  onAnswer,
  clinicId,
}) => {
  const intQuestion = question?.integer;
  const intAnswer = answer?.value?.integer;

  const showSlider = intQuestion?.showSlider;
  const valueMax = intQuestion?.valueMax;
  const valueMin = intQuestion?.valueMin;
  const stepSize = intQuestion?.stepSize;
  const specialMode = intQuestion?.specialMode;
  const unitDatasetId = intQuestion?.unitDatasetId;

  const unitInputPresent = !!intQuestion?.unitDatasetId;

  const [internalValue, setInternalValue] = useState<number>();
  const [internalUnitIdValue, setInternalUnitIdValue] = useState<string>();

  useEffect(() => {
    if (intAnswer?.value !== internalValue) {
      setInternalValue(intAnswer?.value || undefined);
    }
    if (intAnswer?.unitOptionId !== internalUnitIdValue) {
      setInternalUnitIdValue(intAnswer?.unitOptionId || undefined);
    }
  }, [intAnswer]);

  const answerDebounced = useDebouncedCallback((value: number | undefined) => {
    onAnswer({
      integer: {
        value: value,
      },
    });
  }, 400);

  function onValueChange(newValue: number | undefined) {
    setInternalValue(newValue);

    answerDebounced(newValue);
  }

  function onUnitChange(newValue: string | undefined) {
    setInternalUnitIdValue(newValue);

    onAnswer({
      integer: {
        unitOptionId: newValue,
      },
    });
  }

  return (
    <Row>
      <Col flex={"auto"} span={unitInputPresent ? undefined : 24}>
        {showSlider ? (
          <div>
            <Slider
              value={internalValue}
              min={valueMin || 0}
              max={valueMax || 0}
              step={stepSize}
              onChange={onValueChange}
            />
            <div style={{ textAlign: "center" }}>{internalValue || "-"}</div>
          </div>
        ) : (
          <div>
            <InputNumber
              value={internalValue}
              min={valueMin || 0}
              max={valueMax || 10}
              step={stepSize || undefined}
              onChange={(value) => onValueChange(value || undefined)}
            />
          </div>
        )}
      </Col>
      {unitInputPresent && (
        <Col flex={200}>
          <SurveyUnitOptionSelect
            enabled={true}
            selectedOptionId={intAnswer?.unitOptionId}
            setSelectedOption={(v) => onUnitChange(v || undefined)}
            datasetId={unitDatasetId}
            clinicId={clinicId}
          />
        </Col>
      )}
    </Row>
  );
};
